export default __webpack_public_path__ + "static/media/win_one.4cf81525.svg";